// Kunden øverst på en sak, med lenke til kundekortet (vinnsel, 30.10). Felles for ordre, trykk,
// pristilbud, booking og verkstedservice, så kunden ser lik ut overalt.
//
//   kundeId   kundekortets _id; uten den vises banneret uten lenke («Ikke koblet til et kundekort»)
//   navn, telefon, epost   det som vises (saken bestemmer hvor det kommer fra, f.eks. kontaktFor)
//   linje     valgfri tredje linje, f.eks. «Registrert 07.07.2026 · endret …»
//   children  valgfritt innhold under lenken (knapper, merknader). Ligger utenfor lenken, så
//             knapper der ikke åpner kundekortet.
import React from 'react';
import { Link } from 'react-router-dom';
import Ikon from '../ny-kundesamhandling/Ikon';

export default function KundeBanner({ kundeId, navn, telefon, epost, linje, children, className = '' }) {
  const innhold = (
    <>
      <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-sky-700 text-white">
        <Ikon navn="person" className="w-7 h-7" />
      </span>
      <span className="min-w-0 flex-1 basis-48">
        <span className="block text-base font-bold text-slate-900 [overflow-wrap:anywhere]">{navn || 'Uten navn'}</span>
        <span className="block text-slate-700 [overflow-wrap:anywhere]">
          <span className="font-mono">{telefon || 'Uten telefon'}</span>
          {epost && <> · {epost}</>}
        </span>
        {linje && <span className="block text-sm text-slate-600">{linje}</span>}
      </span>
      {kundeId ? (
        <span className="flex items-center gap-1 font-semibold text-indigo-700">
          Kundekortet <Ikon navn="pil" className="w-5 h-5 transition group-hover:translate-x-0.5" />
        </span>
      ) : (
        <span className="text-sm text-slate-600">Ikke koblet til et kundekort</span>
      )}
    </>
  );
  const rad = 'flex flex-wrap items-center gap-2 p-3';

  return (
    <div className={`rounded-2xl border border-sky-200 bg-sky-50 ${className}`}>
      {kundeId ? (
        <Link
          to={`/customer-details/${kundeId}`}
          className={`group ${rad} rounded-2xl transition hover:bg-sky-100 focus:outline-none focus-visible:ring-4 focus-visible:ring-indigo-600/50`}
        >
          {innhold}
        </Link>
      ) : (
        <div className={rad}>{innhold}</div>
      )}
      {children && <div className="space-y-1 border-t border-sky-200 px-3 py-2 text-sm">{children}</div>}
    </div>
  );
}
